import * as React from 'react';
import { styled } from '@mui/material/styles';
import {
  Toolbar,
  ToolbarButton,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  ExportCsv,
  QuickFilter,
  QuickFilterControl,
  QuickFilterClear,
  QuickFilterTrigger,
} from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import Badge from '@mui/material/Badge';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
import EmailIcon from '@mui/icons-material/Email';
import IconButton from '@mui/material/IconButton';
import PersonIcon from '@mui/icons-material/Person';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import Button from '@mui/material/Button';

const StyledQuickFilter = styled(QuickFilter)({
  display: 'grid',
  alignItems: 'center',
});

const StyledToolbarButton = styled(ToolbarButton)(({ theme, ownerState }) => ({
  gridArea: '1 / 1',
  width: 'min-content',
  height: 'min-content',
  zIndex: 1,
  opacity: ownerState.expanded ? 0 : 1,
  pointerEvents: ownerState.expanded ? 'none' : 'auto',
  transition: theme.transitions.create(['opacity']),
}));

const StyledTextField = styled(TextField)(({ theme, ownerState }) => ({
  gridArea: '1 / 1',
  overflowX: 'clip',
  width: ownerState.expanded ? 260 : 'var(--trigger-width)',
  opacity: ownerState.expanded ? 1 : 0,
  transition: theme.transitions.create(['width', 'opacity']),
}));

function CustomToolbar({
  showResendEmail = false,
  onResendEmail,
  selectedRow,
  showUserActions = false,
  onEnableUser,
  onDisableUser,
  showViewPDF = false,
  onViewPDF,
  showEditPlan = false,
  onEditPlan,
  createAction
}) {
  const [exportMenuOpen, setExportMenuOpen] = React.useState(false);
  const exportMenuTriggerRef = React.useRef(null);

  console.log('showResendEmail:', showResendEmail);
  console.log('onResendEmail:', onResendEmail);
  console.log('selectedRow:', selectedRow);
  console.log("create action", createAction)
  return (
    <Toolbar>
      {createAction?.show && (
        <Button
          variant="contained"
          onClick={createAction.onClick}
          sx={{
            backgroundColor: '#22C55E !important',
            color: 'white !important',
            textTransform: 'none',
            padding: '4px 12px',
            fontWeight: '550',
            '&:hover': {
              backgroundColor: '#1EA34F !important',
            },
            mr: 'auto !important',
            mb: 0,
          }}
        >
          {createAction.label || '+ Create'}
        </Button>
      )}

      {showEditPlan && (
        <Tooltip title='Edit Plan'>
          <span>
            <IconButton
              onClick={() => onEditPlan(selectedRow)}
            >
              <EditRoundedIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}

      {showViewPDF && (
        <Tooltip title='View PDF'>
          <span>
            <IconButton
              onClick={() => onViewPDF(selectedRow)}
            >
              <RemoveRedEyeIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {showResendEmail && (
        <Tooltip title="Resend Email">
          <span>
            <IconButton
              onClick={() => onResendEmail(selectedRow)}
            >
              <EmailIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}

      {showUserActions && (
        <>
          <Tooltip title="Enable User">
            <span>
              <IconButton
                onClick={() => onEnableUser(selectedRow)}
              >
                <PersonIcon />
              </IconButton>
            </span>
          </Tooltip>

          <Tooltip title="Disable User">
            <span>
              <IconButton
                onClick={() => onDisableUser(selectedRow)}
              >
                <PersonOffIcon />
              </IconButton>
            </span>
          </Tooltip>
        </>
      )}

      <Tooltip title="Columns">
        <ColumnsPanelTrigger render={<ToolbarButton />}>
          <ViewColumnIcon fontSize="small" />
        </ColumnsPanelTrigger>
      </Tooltip>

      <Tooltip title="Filters">
        <FilterPanelTrigger
          render={(props, state) => (
            <ToolbarButton {...props} color="default">
              <Badge badgeContent={state.filterCount} color="primary" variant="dot">
                <FilterListIcon fontSize="small" />
              </Badge>
            </ToolbarButton>
          )}
        />
      </Tooltip>

      <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 0.5 }} />

      <Tooltip title="Export">
        <ToolbarButton
          ref={exportMenuTriggerRef}
          id="export-menu-trigger"
          aria-controls="export-menu"
          aria-haspopup="true"
          aria-expanded={exportMenuOpen ? 'true' : undefined}
          onClick={() => setExportMenuOpen(true)}
        >
          <FileDownloadIcon fontSize="small" />
        </ToolbarButton>
      </Tooltip>

      <Menu
        id="export-menu"
        anchorEl={exportMenuTriggerRef.current}
        open={exportMenuOpen}
        onClose={() => setExportMenuOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          list: {
            'aria-labelledby': 'export-menu-trigger',
          },
        }}
      >
        <ExportCsv render={<MenuItem />} onClick={() => setExportMenuOpen(false)}>
          Download as CSV
        </ExportCsv>
      </Menu>

      <StyledQuickFilter>
        <QuickFilterTrigger
          render={(triggerProps, state) => (
            <Tooltip title="Search" enterDelay={0}>
              <StyledToolbarButton
                {...triggerProps}
                ownerState={{ expanded: state.expanded }}
                color="default"
                aria-disabled={state.expanded}
              >
                <SearchIcon fontSize="small" />
              </StyledToolbarButton>
            </Tooltip>
          )}
        />
        <QuickFilterControl
          render={({ ref, ...controlProps }, state) => (
            <StyledTextField
              {...controlProps}
              ownerState={{ expanded: state.expanded }}
              inputRef={ref}
              aria-label="Search"
              placeholder="Search..."
              size="small"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                  endAdornment: state.value ? (
                    <InputAdornment position="end">
                      <QuickFilterClear
                        edge="end"
                        size="small"
                        aria-label="Clear search"
                        material={{ sx: { marginRight: -0.75 } }}
                      >
                        <CancelIcon fontSize="small" />
                      </QuickFilterClear>
                    </InputAdornment>
                  ) : null,
                  ...controlProps.slotProps?.input,
                },
                ...controlProps.slotProps,
              }}
            />
          )}
        />
      </StyledQuickFilter>

    </Toolbar>
  );
}

export default CustomToolbar;